"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Policy_1 = require("./Policy");
class MatureLATAMCountryPolicy extends Policy_1.Policy {
    constructor() {
        super(...arguments);
        this.countries = [
            224, 49, 84, 50, 51, 52, 53, 54, 85, 86, 55, 57, 87, 88, 58, 59,
            225, 59, 60, 61, 89, 62, 90, 63, 64, 65, 66, 91, 67, 68, 69, 70,
            71, 72, 74, 75, 92, 93, 76, 77, 78, 80, 223, 94, 81, 226, 83, 95, 96
        ];
    }
    meets(criteria) {
        return this.countries.includes(criteria.countryId);
    }
}
exports.default = new MatureLATAMCountryPolicy();
